function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.917 -8.545)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.516 10.248c.575-.2 5.071-1.7 7.394-1.7s6.856 1.52 7.4 1.706c1.559-.57 3.285-.9 4.189.121 1.162 1.313-.313 3.623-1.83 4.527a11.308 11.308 0 0 1-2.653 1.348 16.449 16.449 0 0 1-2.757 3.4 8.963 8.963 0 0 1-4.349 1.6 8.963 8.963 0 0 1-4.349-1.6A16.434 16.434 0 0 1 7.8 16.242 11.542 11.542 0 0 1 5.165 14.9c-1.517-.9-2.992-3.213-1.83-4.527.902-1.022 2.624-.694 4.181-.125zm12.1 6.774a23.789 23.789 0 0 1-4.66.912 23.789 23.789 0 0 1-4.66-.912 7.9 7.9 0 0 0 4.66 1.742 7.672 7.672 0 0 0 4.662-1.741zm1.243-2.361s-3.935.523-5.9.523-5.9-.523-5.9-.523 3.935 1.495 5.9 1.495 5.902-1.494 5.902-1.494zm1.5.267a8.609 8.609 0 0 0 1.993-1.118c.866-.714 2.25-1.92 1.494-2.924-.529-.7-2-.1-3.487.452zM7.455 11.334c-1.481-.553-2.945-1.148-3.473-.447-.757 1 .627 2.209 1.494 2.924a8.546 8.546 0 0 0 1.979 1.112zm12.591 1.588a46.775 46.775 0 0 0-5.087-.528 46.775 46.775 0 0 0-5.087.528s3.391.445 5.087.445 5.087-.445 5.087-.445z",
  "data-name": "Path 32"
}));

var SvgMaskIcon = function SvgMaskIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12.706,
    viewBox: "0 0 24 12.706",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaskIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mask-icon.ebc20abb.svg";
export { ForwardRef as ReactComponent };